import React, { useState, FormEvent, useRef } from 'react';
import { BaseReact } from '../../base.model';
import Input from '../Forms/Input';
import { Link } from 'react-router-dom';
import Button from '../Forms/Button';
import LogoFullSvg from '../visuals/LogoSvg';
import sharedToasterSubject from '../../services/shared.toasterSubject';
import Turnstile, { TurnstileHandle, TURNSTILE_ENABLED } from '../Forms/Turnstile';
import './Login.scss';


interface LoginProps extends BaseReact {
}

const REST_BASE_URL = (process.env.REACT_APP_HTTP_URL || '').replace(/\/graphql\/?$/, '');

function Login({ history, location }: LoginProps) {
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('');

    const [loggingIn, setLoggingIn] = useState(false);
    const [turnstileToken, setTurnstileToken] = useState('');
    const turnstileRef = useRef<TurnstileHandle>(null);

    const submitLogin = (e: FormEvent) => {
        e.preventDefault();
        if (!email || !password || (TURNSTILE_ENABLED && !turnstileToken)) {
            return;
        }
        setLoggingIn(true);
        fetch(`${REST_BASE_URL}/mainuserlogin`, {
            method: 'POST',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email, password, turnstileToken }),
        })
            .then(async (response) => {
                const data = await response.json().catch(() => ({} as { redirect?: string; error?: string }));
                if (response.ok && data.redirect) {
                    // BE has set the signed cookie; jump to the dashboard URL it told us to.
                    window.location.replace(data.redirect);
                    return;
                }
                sharedToasterSubject.next({
                    type: 'error',
                    message: data.error || 'No se pudo iniciar sesión.',
                });
                // Turnstile tokens are single use, request a fresh one before the next attempt
                turnstileRef.current?.reset();
                setLoggingIn(false);
            })
            .catch((err) => {
                console.error('<Login> Error Logging in: ', err);
                sharedToasterSubject.next({
                    type: 'error',
                    message: 'Error de red, intenta de nuevo.',
                });
                turnstileRef.current?.reset();
                setLoggingIn(false);
            });
    }

    const _setEmail = (e: string) => {
        setEmail(e.trim().toLowerCase())
    }

    return (
        <div id="Login">
            <form className="_loginForm" onSubmit={submitLogin}>
                <LogoFullSvg size={275} />
                <Input type="text" label="Email" value={email} onChange={_setEmail} placeholder="Tu email u Seller Token" hasError={false} />
                <Input type="password" label="Contraseña" value={password} onChange={setPassword} placeholder="Contraseña" />
                <Turnstile ref={turnstileRef} action="login" onToken={setTurnstileToken} />
                <div className="actions">
                    <Link to="/recover" >¿Olvidaste tu contraseña?</Link>
                    <Button primary={true} type="submit" accent={false} disabled={loggingIn || !(email && password) || (TURNSTILE_ENABLED && !turnstileToken)}>
                        {
                            loggingIn ?
                                <span>Entrando</span>
                                :
                                <span>Entrar</span>
                        }
                    </Button>
                </div>
                <div className="_toRegiser">
                    <Link to="/register">
                        ¿No tienes cuenta? <b>Regístrate</b>
                    </Link>
                </div>
            </form>
        </div>
    )
}

export default Login;
